
// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { TenantProvider } from './TenantProvider';
import { SignedIn, SignedOut } from '@clerk/clerk-react';
import SignInPage from './pages/SignIn';
import ThreatMonitoringPlatform from './drpsmanager2';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public route - Sign in only */}
        <Route path="/sign-in/*" element={<SignInPage />} />
        
        {/* Redirect sign-up attempts to sign-in */}
        <Route path="/sign-up/*" element={<Navigate to="/sign-in" replace />} />
        
        {/* Protected routes */}
        <Route 
          path="/*" 
          element={
            <>
              <SignedIn>
                {/* Tenant context only for signed-in users */}
                <TenantProvider>
                  <ThreatMonitoringPlatform />
                </TenantProvider>
              </SignedIn>

              <SignedOut>
                <Navigate to="/sign-in" replace />
              </SignedOut>
            </>
          } 
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
